module.exports = "https://cdn.landi.com/assets/peilian/offical_website_pc/1.0.41/images/077b7655badbd679447e0a3ff7560af1.png";